<script>
  export let data;
  export let userTasks;
  import { conversion, lang } from "../store/store";
  console.log(data);
  console.log(data);
  console.log(data);
  let convert = (k) => {
    let output = "";
    let hrs = k / 60;
    if (hrs <= 0) {
      hrs = Math.ceil(hrs);
    } else {
      hrs = Math.floor(hrs);
    }
    if (hrs != 0) {
      output = hrs + " " + " H";
    }
    let minutes = Math.abs(k) - Math.abs(hrs) * 60;
    if (minutes != 0) {
      if (hrs != 0) {
        output = output + " " + minutes + " M";
      } else {
        output = output + minutes + " " + " M";
      }
    }
    if (minutes == 0 && hrs == 0) {
      output = "0 " + " M";
    }
    return output;
  };

  let diffrence = data.availableHrs - userTasks.estimation.minEst;
</script>

<div class={diffrence > 0 ? "rightContentGreen" : "rightContent"}>
  <div class="bloc1">
    <div class="enter">
      <div class="subTitle">{$conversion[$lang].taskApproval[7]}</div>
      <h1 class="hoursNbr">
        {convert(data.availableHrs - userTasks.estimation.minEst)}
      </h1>
    </div>
    <div class="enter">
      <div class="subTitle">{$conversion[$lang].taskApproval[3]}</div>
      <h1 class="hoursNbr">
        {convert(data.availableHrs - userTasks.estimation.maxEst)}
      </h1>
    </div>
    <div class="icon"><i class="bx bx-time-five" /></div>
  </div>
  <div class="bloc2">{$conversion[$lang].taskApproval[9]}</div>
</div>

<style>
  * {
    padding: 0;
    margin: 0;
  }

  .subTitle {
    font-size: 0.9em;
  }

  .enter {
    margin-right: 1.5rem;
  }

  .icon i {
    font-size: 3em;
  }

  .bloc2 {
    font-weight: 400;
    font-size: 0.8em;
    padding-left: 2rem;
  }
  .rightContent {
    /* border: 1px solid #0e8f6c; */
    padding: 1rem;
    color: rgba(171, 92, 92, 1);
    height: 9rem;
    min-width: 10rem;
    width: max-content;
    border-radius: 8px;
    background: linear-gradient(
      236deg,
      rgba(171, 92, 92, 0.3),
      rgba(255, 255, 255, 0.59)
    );
  }

  .rightContentGreen {
    /* border: 1px solid #0e8f6c; */
    padding: 1rem;
    color: rgba(171, 92, 92, 1);
    width: max-content;
    height: 9rem;
    border-radius: 8px;
    background: linear-gradient(
      263.87deg,
      #0b7457 2.82%,
      rgba(11, 116, 87, 0.53) 98.98%
    );
    color: white;
  }

  .bloc1 {
    display: flex;
    justify-content: space-evenly;
    align-items: flex-end;
    flex-direction: row;
  }

  @media only screen and (max-width: 1100px) {
    .rightContent {
      height: auto;
    }
  }
</style>
